import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ea1216e")

_pushScopeId("data-v-1ea1216e")
const _hoisted_1 = { class: "loading-mask" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createVNode("span", null, "loading...")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})